import type { RouteRecordRaw } from 'vue-router'
const DefaultLayout = () => import('@/layouts/DefaultLayout.vue')

export const toolsRoutes: RouteRecordRaw[] = [
  {
    path: '/tools' ,
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'tools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'tools.printer.list' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'printers/list',
            name: 'tools.printer.list',
            component: () =>
              import('@/modules/operationsTools/printers/ui/view/printerList.vue')
          },
          {
            path: 'printers/statuses',
            name: 'tools.printer.statuses',
            component: () =>
              import('@/modules/operationsTools/printers/ui/view/printerStatusesList.vue')
          },
          {
            path: 'printers/dashboard',
            name: 'tools.printer.dashboard',
            component: () =>
              import('@/modules/operationsTools/printers/ui/view/printerMonitor.vue')
          },
          {
            path: 'mobile/list',
            name: 'tools.mobile.list',
            component: () =>
              import('@/modules/operationsTools/mobile/view/mobileList.vue')
          },
          {
            path: 'operation-logs/list',
            name: 'tools.operationlogs.list',
            component: () =>
              import('@/modules/operationsTools/operationLogs/view/operationlogsList.vue')
          }
        ]
      }
    ]
  }
]
